var map = {
	"./backgrounds/parralax-bg-1.png": "da8a",
	"./backgrounds/parralax-bg-2.png": "52d6",
	"./backgrounds/triangle_background.png": "e17a",
	"./cardSwiping/acceptButtonImage.png": "78ea",
	"./cardSwiping/declineButtonImage.png": "41db",
	"./cardSwiping/testImages/books.jpg": "7e2a",
	"./cardSwiping/testImages/dog.jpg": "ddd5",
	"./cardSwiping/testImages/programming.png": "6b5f",
	"./companyLogos/facebook_logo.png": "391c",
	"./companyLogos/google_logo.png": "847d",
	"./home/account-image.png": "db23",
	"./home/duration-image.png": "75ac",
	"./home/identitiet-image.png": "6d69",
	"./logos/kiesreis_logo.png": "6694",
	"./logos/kiesreis_logo_background.png": "cd58",
	"./logos/kieswijs_logo.png": "e3e2",
	"./logos/kieswijs_logo_background.png": "a53f",
	"./pointer-arrow-left.png": "f722",
	"./privacy-policy/kieswijsanalyse_logo.png": "5b57",
	"./waarden/NextIcon.png": "40e6",
	"./waarden/QuestionMarkIcon.png": "f9bf",
	"./waarden/SelectIcon.png": "aaf6",
	"./waarden/inspect_card_icon.png": "6a8a",
	"./waarden/next_round_icon.png": "c63b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";